export const FORMAT_SELECT_UNIT = 0;
export const FORMAT_SELECT_CUSTOM = "custom";
export const FORMAT_SELECT_CREATE = "__create_format__";
